import { h, Component } from 'preact';
import { styled } from '@mui/material/styles';

const ResendOtpContainer = styled('div')`
  .resendText {
    color: #f7f7f7;
  }
  .resendOtpText {
    width: 15.75vw;
    min-width: 43.75px;
    max-width: 105px;
    text-transform: none;
    height: 36px;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #6741d9;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    outline: none;
  }
  .resendOtpTextDisabled{
    background-color: #808080;
    width: 15.75vw;
    min-width: 43.75px;
    max-width: 105px;
    text-transform: none;
    height: 36px;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 16px;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    outline: none;
  }
  .resendText {
    color: #f7f7f7;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    min-width: 103px;
  }
  .resendButtonText{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;

class ResendOTP extends Component {
  state = {
    resendCounter: 30,
  };
  componentDidMount() {
    this.initTimer();
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }
  initTimer = () => {
    this.intervalId = setInterval(this.timer, 1000);
  };

  timer = () => {
    this.setState(
      ({ resendCounter }) => ({
        resendCounter: resendCounter - 1,
      }),
      () => {
        if (this.state.resendCounter === 0) {
          clearInterval(this.intervalId);
        }
      },
    );
  };
  resendOtp = () => {
    const { resendOTP } = this.props;
    resendOTP();
    this.initTimer();
  };
  render() {
    const { resendCounter } = this.state || {};
    const { color } = this.props;
    return (
      <ResendOtpContainer>
        {resendCounter === 0 ? (
          <div
            className='resendOtpText'>
            <span
              className='resendButtonText'
              onClick={() =>
                this.setState({ resendCounter: 30 }, () => this.resendOtp())
              }>
              Resend
            </span>
          </div>
        ) : (
          <div className='resendOtpTextDisabled'>
            <span className='resendButtonText'>
              {resendCounter} sec
            </span>
          </div>
        )}
      </ResendOtpContainer>
    );
  }
}

export default ResendOTP;